import styled from 'styled-components';

export const ContentPadding = styled.div`
  padding: 5.6rem 4.2rem 3.7rem 4.2rem;
`;
